import styled from 'styled-components';

import { SmallParagraph } from '@genially/design-system';

export const VersionText = styled(SmallParagraph)(({ theme: { color, size } }) => ({
  fontSize: size.units(1),
  lineHeight: 'normal',
  color: color.content.secondary.disabled(),
}));
